import { schema } from "normalizr";

export const fiatSchema = new schema.Entity("fiat", {});
export const arrayOfFiatSchemas = new schema.Array(fiatSchema);
